<script>
export default {
    data() {
        return {
            orderFilter: this.$store.getters['calendar/productionOrder'] || {
                id: 'alphabetical',
                name: 'general.alphabetical',
            },
            orderOptions: [
                {
                    id: 'alphabetical',
                    name: 'general.alphabetical',
                },
                {
                    id: 'percentage',
                    name: 'general.percentageCompleted',
                },
            ],
        };
    },
    created() {
        // Set initial value in store if nothing is stored
        if (!this.$store.getters['calendar/productionOrder']) {
            this.$store.commit('calendar/setProductionOrder', this.orderFilter);
        }
    },
    methods: {
        selectOrder() {
            this.$store.commit('calendar/setProductionOrder', this.orderFilter);
            this.$nextTick(() => {
                this.$emit('reloadCalendarEvents');
            });
        },
    },
};
</script>
<template>
    <multiselect
        id="orderFilters"
        style="width: 100%"
        v-model="orderFilter"
        class="mb-1"
        :options="orderOptions"
        :custom-label="(opt) => $t(opt.name)"
        track-by="id"
        :show-labels="false"
        @input="selectOrder"
        :multiple="false"
        :placeholder="$t('general.selectOrder')"
        :allow-empty="false"
    >
    </multiselect>
</template>
